import { forwardRef, type Ref, type SVGProps } from "react";
const IconSmartphoneOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M23 1H9a2 2 0 0 0-2 2v26a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2m0 28H9v-4h14zm0-6H9V9h14zm0-16H9V3h14z" />
    <path d="M16 26a1 1 0 1 0 0 2 1 1 0 1 0 0-2M15 6h2a1 1 0 0 0 0-2h-2a1 1 0 0 0 0 2m-3-2a1 1 0 1 0 0 2 1 1 0 1 0 0-2" />
  </svg>
);
const ForwardRef = forwardRef(IconSmartphoneOutlineSVG);
ForwardRef.displayName = "IconSmartphoneOutline";
export { ForwardRef as IconSmartphoneOutline };
